// extracted by mini-css-extract-plugin
export default {"wrapper":"Profile_wrapper__c0dzi","profile_data":"Profile_profile_data__-Trr5","edit_btn":"Profile_edit_btn__Htjzx"};